module.exports = __webpack_public_path__ + "img/icone_studio_digital.3056a934.png";